import {
  getNetworksInvitationsListQueryOptions,
  getNetworksListQueryOptions,
  type ForManagerLocationDetail,
} from "@sidegigllc/api/client";
import { selectNetworkPros } from "api/queries/engage";
import { groupsQuery } from "domains/pros/containers/GroupList/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: ForManagerLocationDetail; allSources?: boolean };

export const networkProsQuery = ({ location }: QueriesInput) =>
  getNetworksListQueryOptions(location.organization_id, undefined, { query: { select: selectNetworkPros } });

export const invitesQuery = ({ orgId }: { orgId: string }) => getNetworksInvitationsListQueryOptions(orgId);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  groupsQuery(input),
  networkProsQuery(input),
  invitesQuery({ orgId: input.location.organization_id }),
];
